import { UserSettings } from "@org-avp/avp-avengers-user-service-api";

export function getUserSetting<T>(settings: UserSettings | undefined, key: string, transform: (value: string | null | undefined) => T): T {
  return transform(settings?.settings?.find((s) => s.key === key)?.value);
}
